export function formatSessionDateLabel(date: string): string {
  const parsed = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return date;
  }

  return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatPrice(value: number | null): string {
  if (value == null || !Number.isFinite(value)) {
    return '-';
  }

  return value.toFixed(2);
}

export function formatStrike(value: number | null): string {
  if (value == null || !Number.isFinite(value)) {
    return '-';
  }

  return value.toFixed(1);
}

export function formatExposureSnapshotTime(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return 'unknown time';
  }

  return `${new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
  }).format(parsed)} ET`;
}

export function nonEmpty(value: string | null | undefined): string | null {
  return value != null && value !== '' ? value : null;
}
